export const APP_VERSION = '1.0.2';
export const BUILD_DATE = '2026-07-06T13:40:13.887Z';

export const logVersion = () => {
  console.log(
    '%c📚 Portal Pizzini',
    'color: #9BCD65; font-size: 16px; font-weight: bold;'
  );
  console.log(`%cVersión: ${APP_VERSION}`, 'color: #666; font-size: 12px;');
  console.log(`%cBuild: ${BUILD_DATE}`, 'color: #666; font-size: 12px;');
};
